// Smart API URL that uses relative paths in production to avoid CORS/cookie issues
const getApiUrl = () => {
  // In production (when on tradejourn.ai), use relative URL
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    
    // Production domains - use relative URL
    if (hostname === 'tradejourn.ai' || hostname === 'www.tradejourn.ai') {
      return '/api';
    }
    
    // Emergent preview/host domains - use relative URL
    if (hostname.includes('.emergent.host') || hostname.includes('.emergentagent.com')) {
      return '/api';
    }
  }
  
  // Development or fallback - use env variable
  return `${process.env.REACT_APP_BACKEND_URL || ''}/api`;
};

export const API = getApiUrl();
export default API;
